module.exports = __webpack_public_path__ + "img/empty-network.3694dbda.svg";